export default "__VITE_ASSET__861f188d__"